import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { viewDocAction, viewTranslationsJobAction } from '../../redux/actions/translationAction';
import { IoArrowBack } from 'react-icons/io5';
import PptxEditor from '../../components/editors/pptx/pptx-editor';
import PdfEditor from '../../components/editors/pdf/pdf-editor';
import { Spinner } from 'react-bootstrap';
import DocxEditor from '../../components/editors/docx/docx-editor';
import HtmlEditor from '../../components/editors/html/html-editor';

export const NewEditDocument = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams()
    const documentDataRef = useRef(null)
    const [isLoading, setLoading] = useState(false);
    const [sourceFileUrl, setSourceFileUrl] = useState(null);
    const [targetFileUrl, setTargetFileUrl] = useState(null);
    const [documentData, setDocumentData] = useState(null);

    const fileType = documentData?.file_name?.split('.').pop();

    console.log('fileType :>> ', fileType);
    const onError = (data) => {
        errorToast(data?.data?.message)
    }

    useEffect(() => {
        if (id) {
            setLoading(true)
            dispatch(viewTranslationsJobAction({ id }, onSuccess, onError));
        }
    }, [id]);

    const onSuccess = (data) => {
        const documentData = data?.data?.data;
        setDocumentData(documentData);
        documentDataRef.current = documentData;
        setSourceFileUrl(documentData?.sourceSignedUrl)   
        setTimeout(() => {
            dispatch(viewDocAction({ jobId: id }, onFetchDocSuccess, onError));
        }, 500);
    };
    const onFetchDocSuccess = (data) => {
        setTargetFileUrl(data.data.data);
        setLoading(false)
    }

    return (
        <div className='d-flex vh-100 overflow-auto flex-column border' style={{ backgroundColor: '#E9EEF7' }}>
            <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                <span className="px-3 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                <h2 className="fs_20 fw_400 fn_Roboto text-start pt-1"> Post Editing</h2>
            </div>

            {
                (isLoading && !fileType) &&
                <div className="d-flex justify-content-center align-items-center m-2 bg-white rounded-4" style={{ height: "100%" }}>
                    <Spinner animation="border" variant="primary" />
                </div>
            }
            {
                fileType === "pptx" &&
                <PptxEditor documentData={documentData} sourceFileUrl={sourceFileUrl} translatedFileUrl={targetFileUrl} job_id={id} isLoading={isLoading} />
            }
            {
                fileType === "pdf" &&
                <PdfEditor documentData={documentData} sourceFileUrl={sourceFileUrl} translatedFileUrl={targetFileUrl} job_id={id} isLoading={isLoading} />
            }
            {
                fileType === "docx" &&
                <DocxEditor documentData={documentData} sourceFileUrl={sourceFileUrl} translatedFileUrl={targetFileUrl} job_id={id} isLoading={isLoading} />
            }
            {
                fileType === "html" &&
                <HtmlEditor documentData={documentData} sourceFileUrl={sourceFileUrl} translatedFileUrl={targetFileUrl} job_id={id} isLoading={isLoading} />
            }
        </div >
    )
}
